import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import locations from '../data/locations.json';
import { useLocationRoute, sharedPaths } from '../data/locationRoutes';
import './locations.scss';

export function mapUrl(shop, apple = false) {
    if (shop.googleMaps) return shop.googleMaps;
    const address = `${shop.street}, ${shop.city}, VA ${shop.zip}`;
    return apple ? `https://maps.apple.com/?q=${encodeURIComponent(address)}` : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
}
export function LocationInfo({ shop }) {
    return <section className="location-details" aria-label={`${shop.city} contact information`}>
        <div className="location-visit">
            <p className="location-eyebrow">GOLDWrench Automotive</p>
            <h2>{shop.city}, VA</h2>
            <address><a href={mapUrl(shop)}>{shop.street}<br />{shop.city}, VA {shop.zip}</a></address>
            <div className="location-actions">
                <a className="location-call" href={`tel:${shop.phone}`} aria-label={`Call the ${shop.city} shop at ${shop.displayPhone}`}>
                    <span>Call {shop.city}</span><span>{shop.displayPhone}</span>
                </a>
                <a className="location-directions" href={mapUrl(shop)}>Get directions<span className="visually-hidden"> to {shop.city}</span><span aria-hidden="true"> ↗</span></a>
            </div>
        </div>
        <div className="location-schedule">
            <h3>Operating Hours</h3>
            <dl>{shop.hours.map(([day, hours]) => <div key={day}><dt>{day}</dt><dd>{hours}</dd></div>)}</dl>
        </div>
    </section>;
}
export default function LocationLinks() {
    const { shop: selected, page } = useLocationRoute();
    const suffix = sharedPaths.includes(page) ? page : '';
    return <nav className="location-selector" aria-label="Choose a location">
        <span>{selected ? "Your location:" : "Locations & hours:"}</span>
        {locations.map(shop => <NavLink className="location-choice" key={shop.id} to={`/${shop.id}${suffix}`}>{shop.city}, VA</NavLink>)}
        {selected && page !== '/contact' && <Link className="location-hours-link" to={`/${selected.id}/contact`}>Hours &amp; directions <span aria-hidden="true">→</span></Link>}
    </nav>;
}
